import actions from '../../actionTypes';

export default () => {
  return {
    type: actions.CLOSE_STREAM_TAGS
  };
};



// WEBPACK FOOTER //
// ./src/reducers/tags/actions/closeStreamTags.js